module.exports = __webpack_public_path__ + "img/lunchText.caeac878.png";